import { UI_LOADING_START } from 'actions/Types';

const startUILoading = key => {
  return dispatch => {
    const action = {
      type: UI_LOADING_START,
      key
    };
    dispatch(action);
  };
};

export default startUILoading;
